import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_POLD_INSTANCE_IN_INCIDENT = gql`
  mutation addOrUpdatePoldInstanceInIncident(
    $input: AddOrUpdatePoldInstanceInIncidentInput!
  ) {
    addOrUpdatePoldInstanceInIncident(input: $input) {
      addressUuid
      businessUuid
      incidentUuid
      poldInstanceUuid
      clientMutationId
      errors
      poldInstance {
        id
        address {
          id
          name
        }
        business {
          id
          personalAttribute {
            lastName
            firstName
          }
        }
        createdAt
        hasPold
        incident {
          id
        }
        updatedAt
      }
    }
  }
`;
